/**
 * @ngdoc directive
 * @name bbAccessibleGridEscape
 *
 * @description
 * Directive tightly connected with bbAccessibleGrid. Every HTML element that is tagged with this directive may be
 * taken into account when user want to escape from bb-accessible-calendar-grid element.
 */

function link(scope, element) {
    // Every escapable element need to be focusable as well.
    element.attr('tabindex', '0');
}

const bbAccessibleGridEscape = () => {
    return {
        restrict: 'A',
        link
    };
};

angular
    .module('BBPublicBooking')
    .directive('bbAccessibleGridEscape', bbAccessibleGridEscape);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/time-ranges/accessible-grid/accessible_calendar_grid_escape.directive.js